































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { LiteratureViewModel, LiteratureService } from '../../api/literature';
import { HotChapterService, HotChapterViewModel } from '../../api/hotChapter';
import HotChapter from './HotChapter.vue';
import Advice from './Advice.vue';
import AdviceList from './AdviceList.vue';
import rangy from 'rangy';
import { Message } from 'element-ui';
import BScroll from 'better-scroll';
import FavoriteButton from '../Favorite/FavoriteButton.vue';
@Component({
  components: {
    HotChapter,
    Advice,
    AdviceList,
    FavoriteButton,
  },
})
export default class LiteratureDetail extends Vue {
  private service: LiteratureService = new LiteratureService();
  private data: LiteratureViewModel = this.service.NewModel;
  private chapterService: HotChapterService = new HotChapterService();
  private chapterData: HotChapterViewModel = this.chapterService.NewModel;
  private content: string = '';
  private categoryData: any = {};
  private literatureId: string = '';
  private pageHeight: string = '500px';
  private showCopyButton: boolean = false;
  private copyButtonTop: number = 0;
  private copyButtonLeft: number = 0;
  private showAdvice: boolean = false;
  private contentScroll!: any;
  private created() {
    this.pageHeight = (window.innerHeight - 150) + 'px';
    const literatureId: string = this.$route.query.id + '';
    if (literatureId && literatureId !== '') {
      this.chapterData.literatureID = literatureId;
      this.service.Get(literatureId).then((response: any) => {
        this.data = response;
        this.categoryData = JSON.parse(this.data.category!);
        // console.log(this.categoryData);

        this.content = this.formatContent(this.data.content!);
        this.literatureId = literatureId;
        this.$nextTick(() => {
          const treeScroll = new BScroll(this.$refs['tree-container'] as any, {
            mouseWheel: {
              speed: 2,
              invert: false,
              easeTime: 300,
            },
            scrollbar: {
              fade: false,
              interactive: true,
            },
          });
          this.contentScroll = new BScroll(this.$refs['content-container'] as any, {
            mouseWheel: {
              speed: 2,
              invert: false,
              easeTime: 300,
            },
            scrollbar: {
              fade: false,
              interactive: true,
            },
            disableMouse: true,
          });
        });
      });
    }
  }
  private formatContent(content: string) {
    let result: string = '<div>';
    const contentArray = content.split('\n');
    const reg = /^%(.*?) \*(.*?)\*$/;
    let contentIndex: number = 1;
    let currentMenu: string = '';
    for (const line of contentArray) {
      const menu = reg.exec(line.trim());
      if (menu !== null) {
        contentIndex = 1;
        currentMenu = menu[2];
        result += `</div><div id='${menu[2]}-c'><p id='${menu[2]}-0' class='h${menu[1].lastIndexOf('%')}'>${menu[1].replace(/%/ig, '')}</p>`
      } else {
        result += `<p id='${currentMenu}-${contentIndex++}'>${line}</p>`;
      }
    }
    // result = content.replace(/\n/ig, '<br>');
    return result + '</div>';
  }
  private node_OnClick(key: any) {
    const param = document.getElementById(key + '-c');
    console.log(key);
    if (param) {
      // param.scrollIntoView();
      // (document.getElementById('literature-content') as any).scrollTo(0, param.offsetTop);
      this.contentScroll.scrollToElement(param, 200);
    }
  }
  private getFirstRange() {
    const sel = rangy.getSelection();
    return sel.rangeCount ? sel.getRangeAt(0) : null;
  }
  private getCategory() {
    let result = '';
    const selection = this.getFirstRange();
    if (selection) {
      let node = selection.endContainer.parentNode as any;
      while (node.attributes === undefined || node.attributes['id'] === undefined) {
        node = node.parentNode;
      }
      let categoryId = (node as any).attributes['id'].nodeValue;
      if (categoryId !== '') {
        categoryId = categoryId.replace('-c', '');
        // var categoryNode = document.getElementById(categoryId) as any;
        // if (categoryNode) {
        //   result = categoryNode.outerText;
        // }
        let categoryNode;
        const categorySplit = categoryId.split('-');
        for (let index = categorySplit.length - 1; index >= 0  ; index--) {
          categorySplit[index] = 0;
          categoryNode = document.getElementById(categorySplit.join('-')) as any;
          if (categoryNode) {
            result = `${categoryNode.outerText}·${result}`;
          }
        }
      }
    }
    return result && result !== '' ? `《${result.substring(0, result.length - 1)}》` : '';
  }
  private content_OnMouseUp(e: any) {
    const selection = this.getFirstRange();
    if (selection && selection.toString() !== '') {
      this.copyButtonTop = e.pageY - 150;
      this.copyButtonLeft = e.pageX - 410;
      this.showCopyButton = true;
    } else {
      this.showCopyButton = false;
    }
    // console.log(this.getCategory());
  }
  private btnCopy_OnClick() {
    this.showCopyButton = false;
    const selection = this.getFirstRange();
    if (selection) {
      let content = selection.toString();
      content += this.getCategory();
      this.addCount(selection);
      (this as any).$copyText(content).then((e: any) => {
        Message.success('复制成功！');
      });
    }
    // console.log(this.getCategory());
  }
  private addCount(selection: any) {
    let chapterId = selection.startContainer.parentNode.attributes['id'].nodeValue;
    this.chapterData.chapterID = chapterId;
    this.chapterService.Update(this.chapterData).then(() => {
      chapterId = selection.endContainer.parentNode.attributes['id'].nodeValue;
      if (this.chapterData.chapterID !== chapterId) {
        this.chapterData.chapterID = chapterId;
        this.chapterService.Update(this.chapterData);
      }
    });
  }
  private content_OnScoll(e: any) {
    // console.log(e.target.scrollTop);
    // this.copyButtonTop = this.copyButtonTop + e.target.scrollTop;
    this.showCopyButton = false;
  }
  private btnSaveAdvice_OnClick() {
    (this.$refs.advice as any).Save();
  }
  private advice_OnSave(entity: any) {
    Message.success('保存成功！');
    this.showAdvice = false;
  }
}
